import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";

import Examples from "../../Docs/Components/TagPicker/TagPickerExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Tag picker"
            description="A tag picker is used to select one or more tags from a list."
            apiSources={["azure-devops-ui/Components/TagPicker/TagPicker.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
        />
    );
}
}
        
export default Page;